import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      quote: `AI Clean Core's technical implementation exceeded our expectations. Their open-source approach gave us complete control over our AI infrastructure, and the performance improvements were immediate and measurable.`,
      author: "Sarah Chen",
      role: "Chief Technology Officer",
      company: "TechFlow Industries",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      concern: "Technical Excellence",
      metrics: {
        "Performance Improvement": "67%",
        "Cost Reduction": "$2.4M annually",
        "Implementation Time": "4 months"
      }
    },
    {
      id: 2,
      quote: `The ROI was clear within 6 months. Moving away from vendor lock-in saved us millions while giving us capabilities that proprietary solutions couldn't match. This was a strategic game-changer for our organization.`,
      author: "Michael Rodriguez",
      role: "Chief Financial Officer",
      company: "Global Manufacturing Corp",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      concern: "ROI Achievement",
      metrics: {
        "Annual Savings": "$4.2M",
        "ROI Timeline": "6 months",
        "Efficiency Gains": "45%"
      }
    },
    {
      id: 3,
      quote: `Their strategic assessment helped us avoid costly mistakes and focus on AI initiatives that truly matter. The roadmap they developed became our north star for digital transformation.`,
      author: "Jennifer Park",
      role: "Chief Executive Officer",
      company: "Innovation Dynamics",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      concern: "Strategic Planning",
      metrics: {
        "Projects Prioritized": "12",
        "Risk Mitigation": "89%",
        "Strategy Alignment": "100%"
      }
    }
  ];

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-text-primary mb-4">
          What Our Clients Say
        </h3>
        <p className="text-text-secondary max-w-2xl mx-auto">
          Real results from real transformations. See how organizations like yours achieved AI independence and measurable business outcomes.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {testimonials?.map((testimonial) => (
          <div key={testimonial?.id} className="bg-white rounded-xl border border-gray-200 p-6 hover:shadow-executive transition-all duration-300">
            <div className="mb-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <Icon name="Quote" size={20} color="var(--color-brand-primary)" />
                  <span className="text-sm font-medium text-brand-primary">
                    {testimonial?.concern}
                  </span>
                </div>
                <div className="flex text-brand-secondary">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon key={i} name="Star" size={16} color="var(--color-brand-secondary)" />
                  ))}
                </div>
              </div>
              
              <blockquote className="text-text-secondary leading-relaxed">
                "{testimonial?.quote}"
              </blockquote>
            </div>

            <div className="border-t border-gray-200 pt-4 mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-semibold text-text-primary">
                    {testimonial?.author}
                  </div>
                  <div className="text-sm text-text-secondary">
                    {testimonial?.role}
                  </div>
                  <div className="text-sm text-brand-primary">
                    {testimonial?.company}
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-brand-surface rounded-lg p-4">
              <h5 className="font-semibold text-text-primary mb-3 text-sm">
                Key Results:
              </h5>
              <div className="space-y-2">
                {Object.entries(testimonial?.metrics)?.map(([metric, value], index) => (
                  <div key={index} className="flex justify-between items-center">
                    <span className="text-sm text-text-secondary">{metric}:</span>
                    <span className="text-sm font-semibold text-brand-primary">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSection;